// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.text-container[data-v-0942c9e8]{\n\tmax-width: 700px;\n\tfont-size: 18pt;\n\ttext-align:center;\n\tpadding-bottom: 32px;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
